import Catalog from "./Catalog";
import Cart from "./Cart";
import { productDb } from "./productDb";
import Product from "./Product";
var Store = /** @class */ (function () {
    function Store() {
        this.catalog = new Catalog();
        this.cart = new Cart();
    }
    Store.prototype.getProducts = function () {
        var _this = this;
        productDb.forEach(function (p) {
            var product = new Product();
            product.id = p.id;
            product.img = p.img;
            product.name = p.name;
            product.description = p.description;
            product.price = Math.floor(Math.random() * (2500 - 700)) + 700;
            _this.catalog.add(product);
        });
    };
    return Store;
}());
export default Store;
